import { ReactNode } from 'react';
import { motion, Variants } from 'framer-motion';
import { STAGGER, TRANSITION } from 'shared/components/motion/tokens';

const container: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: STAGGER } },
};

const item: Variants = {
  hidden: { opacity: 0, y: 14, scale: 0.98 },
  visible: { opacity: 1, y: 0, scale: 1, transition: TRANSITION },
};

interface StaggerProps {
  children: ReactNode;
  className?: string;
}

// Grupo cujos filhos <StaggerItem> entram um depois do outro quando o grupo aparece na tela.
export function StaggerGroup({ children, className }: StaggerProps) {
  return (
    <motion.div
      className={className}
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '0px 0px -40px 0px' }}
    >
      {children}
    </motion.div>
  );
}

export function StaggerItem({ children, className }: StaggerProps) {
  return (
    <motion.div className={className} variants={item}>
      {children}
    </motion.div>
  );
}
